"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @ts-ignore

/** Wrapper for icons to include space */
var Icon = _styledComponents.default.svg.attrs({}).withConfig({
  displayName: "Icon",
  componentId: "sc-1eovgys-0"
})(["position:relative;", ";", ";", ";", ";", ";"], _styledSystem.space, _styledSystem.top, _styledSystem.right, _styledSystem.left, _styledSystem.position);

exports.Icon = Icon;
Icon.defaultProps = {
  fill: "black100",
  height: "18px",
  width: "18px"
};
//# sourceMappingURL=Icon.js.map